import { useTranslations } from "next-intl";

import { AccountBankAccount, BankAccountSummary } from "@generated/types";

export interface BankAccountValue {
  key: string;
  label: string;
  value: string;
  isCountry?: boolean;
}

const useBankAccountValues = (
  bankAccount: AccountBankAccount | BankAccountSummary | null | undefined
): BankAccountValue[] => {
  const tBankAccount = useTranslations("bankAccount");

  if (!bankAccount) {
    return [];
  }

  const {
    accountName,
    country,
    nationalClearingCode,
    accountNumber,
    iban,
    bic,
  } = bankAccount;

  return [
    {
      key: "accountName",
      label: tBankAccount("fields.accountName.default.label"),
      value: accountName,
    },
    {
      key: "accountNumber",
      label:
        tBankAccount(`fields.accountNumber.${country}.label`) ||
        tBankAccount("fields.accountNumber.default.label"),
      value: accountNumber,
    },
    {
      key: "nationalClearingCode",
      label:
        tBankAccount(`fields.nationalClearingCode.${country}.label`) ||
        tBankAccount("fields.nationalClearingCode.default.label"),
      value: nationalClearingCode,
    },
    {
      key: "bic",
      label:
        tBankAccount(`fields.bic.${country}.label`) ||
        tBankAccount("fields.bic.default.label"),
      value: bic,
    },
    {
      key: "iban",
      label:
        tBankAccount(`fields.iban.${country}.label`) ||
        tBankAccount("fields.iban.default.label"),
      value: iban,
    },
    {
      key: "country",
      label: tBankAccount("fields.country.default.label"),
      value: country,
      isCountry: true,
    },
  ].filter((field): field is BankAccountValue => !!field.value);
};

export default useBankAccountValues;
